import salesrepConfig from "emun.salesrep/salesrep.config";
import resolve from "ioc/resolve";
import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";
import ServiceBus from "servicestack/service-bus";
import modals from "webmodals/modals";

class ShowroomDashboardController {
  constructor($scope) {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.bus = new ServiceBus();
    let $rootScope = resolve("$rootScope");
    //$ctrl.today = moment.utc("01/15/2021", "MM/DD/YYYY");
    $ctrl.today = moment.utc();
    //$ctrl.yesterday = moment.utc("01/15/2021", "MM/DD/YYYY").subtract(1, 'days');
    $ctrl.yesterday = moment.utc().subtract(1, "days");
    $ctrl.salesrepConfig = salesrepConfig;
  }
  $onInit() {
    const $ctrl = this;
    $ctrl.bus
      .send("QueryShowCodes.json?All=1&ShowOnDashboard=1&OrderBy=Name")
      .then((args) => ($ctrl.showCodes = args.data.results));
    $ctrl.bus
      .send("QueryMarketDates.json?GroupBy=Year&OrderBy=-Year")
      .then((args) => ($ctrl.years = args.data.results));
    $ctrl.piechartLabels = [];
    $ctrl.piechartData = [];
    $ctrl.linechartLabels = [];
    $ctrl.linechartData = [];
    $ctrl.colors = salesrepConfig.chartColors;
    $ctrl.piechartOptions = {
      maintainAspectRatio: false,
      legend: {
        display: true,
      },
      tooltips: {
        enabled: true,
        callbacks: {
          label: function (tooltipItem, data) {
            var label = data.labels[tooltipItem.index];
            let datasetLabel =
              data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            return (
              label +
              ": $" +
              datasetLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
              "  (" +
              Math.round((datasetLabel / $ctrl.pieChartTotal) * 100) +
              "%)"
            );
          },
        },
      },
    };
    $ctrl.quickReportsQuery = new AutoQuery({
      url: "QueryQuickReports.json?",
      orderBy: "Type,Name",
      sortOptions: {
        "Type,Name": "Name: A to Z",
        "-Type,Name": "Name: Z to A",
      },
      tagCriteria: {
        Dashboards: "Showroom",
      },
      autoLoad: true,
      onLoaded(args) {
        $ctrl.quickReports = args.results;
      },
      pageSize: 1000,
    });

    $ctrl.linechartOptions = {
      maintainAspectRatio: false,
      legend: {
        display: true,
        labels: {
          boxWidth: 5,
          fontSize: 10,
        },
      },
      elements: {
        rectangle: {
          borderWidth: 1,
        },
      },
      scales: {
        yAxes: [
          {
            id: "y-axis-1",
            type: "linear",
            display: true,
            position: "left",
            ticks: {
              callback: function (value, index, values) {
                return (
                  "$" + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                );
              },
            },
          },
        ],
      },
      tooltips: {
        enabled: true,
        yAlign: "bottom",
        callbacks: {
          label: function (tooltipItem, data) {
            var label = data.datasets[tooltipItem.datasetIndex].label;
            var datasetLabel =
              data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            return (
              label +
              ": " +
              datasetLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            );
          },
        },
      },
    };
    $ctrl.mode = "list";
    $ctrl.showDailyTotals = new AutoQuery({
      url: "QueryMarketDailyTotals.json",
      criteria: {},
      autoLoad: false,
      onLoaded: function (args) {
        $ctrl.todaySales = {
          total: 0,
          count: 0,
          avg: 0,
          goal: 0,
          ly: 0,
          customers: 0,
          customerAvg: 0,
        };
        $ctrl.yesterdaySales = {
          total: 0,
          count: 0,
          avg: 0,
          goal: 0,
          ly: 0,
          customers: 0,
          customerAvg: 0,
        };
        $ctrl.cumulativeSales = {
          total: 0,
          count: 0,
          avg: 0,
          goal: 0,
          ly: 0,
          customers: 0,
          customerAvg: 0,
        };
        $ctrl.dailySales = _.groupBy(args.results, "dayNum");
        args.results.forEach(function (day) {
          if (day.dayNum >= $ctrl.beginDay && day.dayNum <= $ctrl.endDay) {
            $ctrl.cumulativeSales.total += day.salesTotal;
            $ctrl.cumulativeSales.count += day.salesCount;
            if ($ctrl.cumulativeSales.count > 0)
              $ctrl.cumulativeSales.avg =
                $ctrl.cumulativeSales.total / $ctrl.cumulativeSales.count;
          }
          if (
            moment.utc(day.showDate).format("MM/DD/YYYY") ===
            $ctrl.today.format("MM/DD/YYYY")
          ) {
            $ctrl.todaySales.total = day.salesTotal;
            $ctrl.todaySales.count = day.salesCount;
            $ctrl.todayDayNum = day.dayNum;
            if ($ctrl.todaySales.count > 0)
              $ctrl.todaySales.avg =
                $ctrl.todaySales.total / $ctrl.todaySales.count;
          }
          if (
            moment.utc(day.showDate).format("MM/DD/YYYY") ===
            $ctrl.yesterday.format("MM/DD/YYYY")
          ) {
            $ctrl.yesterdaySales.total = day.salesTotal;
            $ctrl.yesterdaySales.count = day.salesCount;
            $ctrl.yesterdayDayNum = day.dayNum;
            if ($ctrl.yesterdaySales.count > 0)
              $ctrl.yesterdaySales.avg =
                $ctrl.yesterdaySales.total / $ctrl.yesterdaySales.count;
          }
        });
        $ctrl.showGoals.load();
        $ctrl.showDailyTotalsLY.load();
        $ctrl.customersQuery.load();
        $ctrl.regionQuery.load();
        if ($ctrl.salesrepConfig.goalsBy === "Category") {
          $ctrl.categoryQuery.load();
          $ctrl.categoryDailyQuery.load();
        } else if ($ctrl.salesrepConfig.goalsBy === "Vendor") {
          $ctrl.vendorQuery.load();
          $ctrl.vendorDailyQuery.load();
        }
        // $ctrl.loadAppointments();
        $ctrl.loadDailyAppointments();
      },
      pageSize: 1000,
    });
    $ctrl.showGoals = new AutoQuery({
      url: "QueryShowGoals.json",
      criteria: {},
      autoLoad: false,
      onLoaded: function (args) {
        args.results.forEach(function (day) {
          if (day.day >= $ctrl.beginDay && day.day <= $ctrl.endDay) {
            $ctrl.cumulativeSales.goal += day.dollarAmount;
            $ctrl.cumulativeSales.goalPercent = Math.round(
              ($ctrl.cumulativeSales.total / $ctrl.cumulativeSales.goal) * 100
            );
          }
          if (day.day == $ctrl.todayDayNum) {
            $ctrl.todaySales.goal += day.dollarAmount;
            $ctrl.todaySales.goalPercent = Math.round(
              ($ctrl.todaySales.total / $ctrl.todaySales.goal) * 100
            );
          }
          if (day.day == $ctrl.yesterdayDayNum) {
            $ctrl.yesterdaySales.goal += day.dollarAmount;
            $ctrl.yesterdaySales.goalPercent = Math.round(
              ($ctrl.yesterdaySales.total / $ctrl.yesterdaySales.goal) * 100
            );
          }
        });
      },
      pageSize: 1000,
    });
    $ctrl.showDailyTotalsLY = new AutoQuery({
      url: "QueryMarketDailyTotals.json",
      criteria: {},
      autoLoad: false,
      onLoaded: function (args) {
        args.results.forEach(function (day) {
          if (day.dayNum >= $ctrl.beginDay && day.dayNum <= $ctrl.endDay) {
            $ctrl.cumulativeSales.ly += day.salesTotal;
            $ctrl.cumulativeSales.lyPercent = Math.round(
              ($ctrl.cumulativeSales.total / $ctrl.cumulativeSales.ly) * 100
            );
          }
          $ctrl.dailySales[day.dayNum][0].salesTotalLY = day.salesTotal;
          $ctrl.dailySales[day.dayNum][0].percentLY = (
            ($ctrl.dailySales[day.dayNum][0].salesTotal / day.salesTotal) *
            100
          ).toFixed(0);

          if (day.dayNum == $ctrl.todayDayNum) {
            $ctrl.todaySales.ly = day.salesTotal;
            $ctrl.todaySales.lyPercent = Math.round(
              ($ctrl.todaySales.total / $ctrl.todaySales.ly) * 100
            );
          }
          if (day.dayNum == $ctrl.yesterdayDayNum) {
            $ctrl.yesterdaySales.ly = day.salesTotal;
            $ctrl.yesterdaySales.lyPercent = Math.round(
              ($ctrl.yesterdaySales.total / $ctrl.yesterdaySales.ly) * 100
            );
          }
        });
      },
      pageSize: 1000,
    });
    $ctrl.customersQuery = new AutoQuery({
      url: "QueryMarketCustomerDailyTotals.json",
      criteria: {},
      autoLoad: false,
      pageSize: 1000,
      onLoaded: function (args) {
        $ctrl.uniqueCustomers = 0;
        args.results.forEach(function (day) {
          if (day.dayNum >= $ctrl.beginDay && day.dayNum <= $ctrl.endDay) {
            $ctrl.cumulativeSales.customers += day.customerCount;
            if ($ctrl.cumulativeSales.customers > 0)
              $ctrl.cumulativeSales.customerAvg =
                $ctrl.cumulativeSales.total / $ctrl.cumulativeSales.customers;
          }
          if (day.dayNum == $ctrl.todayDayNum) {
            $ctrl.todaySales.customers = day.customerCount;
            if ($ctrl.todaySales.customers > 0)
              $ctrl.todaySales.customerAvg =
                $ctrl.todaySales.total / $ctrl.todaySales.customers;
          }
          if (day.dayNum == $ctrl.yesterdayDayNum) {
            $ctrl.yesterdaySales.customers = day.customerCount;
            if ($ctrl.yesterdaySales.customers > 0)
              $ctrl.yesterdaySales.customerAvg =
                $ctrl.yesterdaySales.total / $ctrl.yesterdaySales.customers;
          }
        });
      },
    });
    $ctrl.totalRetailerCount = 0;
    $ctrl.regionQuery = new AutoQuery({
      url: "QueryMarketTotalsRegion.json",
      criteria: {},
      autoLoad: false,
      pageSize: 1000,
      onLoaded: function (args) {
        args.results.forEach(function (obj) {
          obj.avgOrder = Math.round(obj.salesTotal / obj.salesCount);
        });
        $ctrl.regionCustomerQuery.load();
      },
    });
    $ctrl.regionCustomerQuery = new AutoQuery({
      url: "QueryMarketCustomerTotalsRegion.json",
      criteria: {},
      autoLoad: false,
      pageSize: 1000,
      onLoaded: function (args) {
        args.results.forEach(function (obj) {
          $ctrl.regionQuery.results.forEach(function (total) {
            if (total.region === obj.region) {
              total.customerCount = obj.customerCount;
              total.avgPerRetailer = Math.round(
                total.salesTotal / total.customerCount
              );
              $ctrl.totalRetailerCount += obj.customerCount;
            }
          });
        });
      },
    });
    $ctrl.categoryQuery = new AutoQuery({
      url: "QueryMarketTotalsCategory.json",
      criteria: {},
      autoLoad: false,
      pageSize: 1000,
      onLoaded: function (args) {
        $ctrl.piechartLabels = [];
        $ctrl.piechartData = [];
        $ctrl.linechartSeries = [];
        $ctrl.categoryTotal = 0;
        $ctrl.goalTotal = 0;
        $ctrl.pieChartTotal = 0;
        args.results.forEach(function (obj) {
          $ctrl.piechartLabels.push(obj.category);
          $ctrl.linechartSeries.push(obj.category);
          $ctrl.piechartData.push(obj.salesTotal);
          $ctrl.categoryTotal += obj.salesTotal;
          $ctrl.pieChartTotal += obj.salesTotal;
          $ctrl.goalTotal += obj.goal;
        });
        $ctrl.percentGoal = Math.round(
          ($ctrl.categoryTotal / $ctrl.goalTotal) * 100
        );
      },
    });
    $ctrl.categoryDailyQuery = new AutoQuery({
      url: "QueryMarketDailyTotalsCategory.json",
      criteria: {},
      autoLoad: false,
      pageSize: 1000,
      onLoaded: function (args) {
        $ctrl.categoryDays = _.groupBy(args.results, "dayNum");
        $ctrl.uniqueDays = Object.keys($ctrl.categoryDays);
        $ctrl.linechartLabels = [];
        $ctrl.uniqueDays.forEach(function (dayNum) {
          $ctrl.linechartLabels.push("Day " + dayNum);
        });
        $ctrl.dayCategories = _.groupBy(args.results, "category");
        $ctrl.uniqueCategories = Object.keys($ctrl.dayCategories);
        $ctrl.linechartData = [];
        $ctrl.uniqueCategories.forEach(function (category) {
          var data = [];
          $ctrl.dayCategories[category].forEach(function (day) {
            data.push(day.salesTotal);
          });
          $ctrl.linechartData.push(data);
        });
        $ctrl.linechartLoaded = true;
        Object.assign(
          $ctrl.categoryDailyQueryLY.criteria,
          $ctrl.categoryDailyQuery.criteria
        );
        $ctrl.categoryDailyQueryLY.criteria.year =
          $ctrl.categoryDailyQuery.criteria.year - 1;
        $ctrl.categoryDailyQueryLY.load();
      },
    });
    $ctrl.categoryDailyQueryLY = new AutoQuery({
      url: "QueryMarketDailyTotalsCategory.json",
      criteria: {},
      autoLoad: false,
      pageSize: 1000,
      onLoaded: function (args) {
        args.results.forEach(function (ly) {
          $ctrl.categoryDailyQuery.results.forEach(function (ty) {
            if (ly.category == ty.category && ly.dayNum == ty.dayNum) {
              ty.salesTotalLY = ly.salesTotal;
              ty.percentLY = ((ty.salesTotal / ty.salesTotalLY) * 100).toFixed(
                0
              );
            }
          });
        });
      },
    });
    $ctrl.vendorQuery = new AutoQuery({
      url: "QueryMarketTotalsVendor.json",
      criteria: {},
      autoLoad: false,
      pageSize: 1000,
      onLoaded: function (args) {
        $ctrl.piechartLabels = [];
        $ctrl.piechartData = [];
        $ctrl.linechartSeries = [];
        $ctrl.vendorTotal = 0;
        $ctrl.pieChartTotal = 0;
        $ctrl.goalTotal = 0;
        args.results.forEach(function (obj) {
          $ctrl.piechartLabels.push(obj.vendor);
          $ctrl.linechartSeries.push(obj.vendor);
          $ctrl.piechartData.push(obj.salesTotal);
          $ctrl.vendorTotal += obj.salesTotal;
          $ctrl.pieChartTotal += obj.salesTotal;
          $ctrl.goalTotal += obj.goal;
        });
        $ctrl.percentGoal = Math.round(
          ($ctrl.vendorTotal / $ctrl.goalTotal) * 100
        );
      },
    });
    $ctrl.vendorDailyQuery = new AutoQuery({
      url: "QueryMarketDailyTotalsVendor.json",
      criteria: {},
      autoLoad: false,
      pageSize: 1000,
      onLoaded: function (args) {
        $ctrl.vendorDays = _.groupBy(args.results, "dayNum");
        $ctrl.uniqueDays = Object.keys($ctrl.vendorDays);
        $ctrl.linechartLabels = [];
        $ctrl.uniqueDays.forEach(function (dayNum) {
          $ctrl.linechartLabels.push("Day " + dayNum);
        });
        $ctrl.dayVendors = _.groupBy(args.results, "vendor");
        $ctrl.uniqueVendors = Object.keys($ctrl.dayVendors);
        $ctrl.linechartData = [];
        $ctrl.uniqueVendors.forEach(function (vendor) {
          var data = [];
          $ctrl.dayVendors[vendor].forEach(function (day) {
            data.push(day.salesTotal);
          });
          $ctrl.linechartData.push(data);
        });
        $ctrl.linechartLoaded = true;
      },
    });
    $ctrl.quickReportQuery = new AutoQuery({
      url: "QueryQuickReports.json",
      criteria: {
        Type: "Showroom Dashboard",
        OrderBy: "Type,Name",
      },
      autoLoad: true,
      pageSize: 1000,
    });
  }

  runReport(report) {
    const $ctrl = this;
    //console.info("report", report, $ctrl.showCode);
    if (
      $ctrl.showCode == undefined ||
      $ctrl.showCode == "" ||
      $ctrl.days == undefined
    ) {
      modals.alert("You must select a showode and date range!");
      return;
    }
    $ctrl.days.forEach(function (day) {
      if (day.dayNum === $ctrl.beginDay)
        $ctrl.beginDate = moment.utc(day.showDate);
      if (day.dayNum === $ctrl.endDay) $ctrl.endDate = moment.utc(day.showDate);
    });

    let url = $ctrl.$appConfig.resolveServiceUrl(
      "RunReport?reportName=QuickReport&displayName=" +
        report.name +
        " &output=xlsx&QuickReportID=" +
        report.id +
        "&QuickReportName=" +
        report.name +
        "&@ShowCode=" +
        $ctrl.showCode +
        "&@dtmStartDate=" +
        $ctrl.beginDate.format("YYYY-MM-DD") +
        "&@dtmEndDate=" +
        $ctrl.endDate.format("YYYY-MM-DD")
    );

    return (location.href = url);
  }

  loadDailyAppointments() {
    const $ctrl = this;
    $ctrl.activityType =
      $ctrl.salesrepConfig.showroomActivityType || "Show Appointment";
    $ctrl.numAppointmentsGoal = 0;
    $ctrl.dollarAmountGoal = 0;

    this.activities = {
      total: 0,
      count: 0,
      conversions: 0,
      percentConverted: 0,
      salesAmount: 0,
    };
    $ctrl.dailyapptchartData = [];
    $ctrl.dailyapptchartLabels = [];
    $ctrl.appointments = [];
    $ctrl.avgAppointment = 0;

    $ctrl.loadDailyApptChartData = function (args) {
      $ctrl.dailyapptchartData.push($ctrl.appointments);
      $ctrl.dailyapptchartData.push($ctrl.projections);
      $ctrl.dailyapptchartLoaded = true;
    };
    $ctrl.loadApptChartData = function (args) {
      $ctrl.apptchartLabels = ["Appointments"];
      $ctrl.apptchartSeries = ["Actual", "Goal"];
      $ctrl.apptchartData = [];
      $ctrl.apptchartData.push([$ctrl.activities.count]);
      $ctrl.apptchartData.push([$ctrl.numAppointmentsGoal]);
      $ctrl.apptchartLoaded = true;
    };
    $ctrl.loadConvChartData = function (args) {
      $ctrl.convchartLabels = ["Appointments"];
      $ctrl.convchartSeries = ["Actual", "Converted"];
      $ctrl.convchartData = [];
      $ctrl.convchartData.push([$ctrl.activities.count]);
      $ctrl.convchartData.push([$ctrl.activities.conversions]);
      $ctrl.convchartLoaded = true;
    };

    this.activitiesCount = new AutoQuery({
      url:
        "QueryShowAppointmentsByDay.json?showCode=" +
        $ctrl.showCode +
        "&MarketName=" +
        $ctrl.market +
        "&BeginDay=" +
        $ctrl.beginDay +
        "&EndDay=" +
        $ctrl.endDay +
        "&Year=" +
        $ctrl.year +
        "&dateRange=calendar&Sum=Appointments&groupBy=ShowCode,ShowDay&orderBy=ShowCode,ShowDay",
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (args) {
        args.results.forEach(function (total) {
          $ctrl.dailyapptchartLabels.push(
            moment.utc(total.showDay).format("MM/DD/YY")
          );
          //					$ctrl.chartLabels.push([moment(total.showDay).format("ddd"),moment(total.showDay).format("MM/DD")]);
          $ctrl.appointments.push(total.sumAppointments);
          $ctrl.activities.count += total.sumAppointments;
        });
        $ctrl.days.forEach(function (day) {
          if (day.dayNum === $ctrl.beginDay)
            $ctrl.beginDate = moment.utc(day.showDate);
          if (day.dayNum === $ctrl.endDay)
            $ctrl.endDate = moment.utc(day.showDate);
        });
        $ctrl.activitiesByAccountType = [];
        $ctrl.bus
          .read(
            "QueryActivitiesJoin.json?showCode=" +
              $ctrl.showCode +
              "&StartDateGreaterThan=" +
              moment.utc($ctrl.beginDate).add("days", -1).format("MM/DD/YY") +
              "&StartDateLessThan=" +
              moment.utc($ctrl.endDate).add("days", 1).format("MM/DD/YY") +
              "&GroupBy=AccountType"
          )
          .then(function (res) {
            res.data.results.forEach(function (obj) {
              $ctrl.activitiesByAccountType.push({
                accountType: obj.accountType,
                numActivities: obj.Total,
              });
            });
          });

        if ($ctrl.projectionDollar > 0) {
          $ctrl.avgAppointment = $ctrl.projectionDollar;
          $ctrl.projections = [];
          $ctrl.appointments.forEach(function (a) {
            $ctrl.projections.push(Math.round(a * $ctrl.avgAppointment));
          });
          $ctrl.loadDailyApptChartData();
        } else {
          $ctrl.weeklyAverageQuery = new AutoQuery({
            url:
              "QueryWeeklyBookingAverageShow?count=weeknumber&sum=WeekAvg&WeekAvgLessThan=1000000&GroupBy=SalesRep&showcode=" +
              $ctrl.projectionShowCode,
            pageSize: 1000,
            autoLoad: true,
            onLoaded: function (avgArgs) {
              var totalavg = 0;
              avgArgs.results.forEach(function (result) {
                totalavg += result.sumWeekAvg / result.countweeknumber;
              });
              $ctrl.avgAppointment = totalavg / avgArgs.total;
              $ctrl.projections = [];
              $ctrl.appointments.forEach(function (a) {
                $ctrl.projections.push(Math.round(a * $ctrl.avgAppointment));
              });
              $ctrl.loadDailyApptChartData();
            },
          });
        }
        $ctrl.conversionCount = new AutoQuery({
          url:
            "QueryMarketDailyConversions.json?market=" +
            $ctrl.market +
            "&showCode=" +
            $ctrl.showCode +
            "&BeginDay=" +
            $ctrl.beginDay +
            "&EndDay=" +
            $ctrl.endDay +
            "&Year=" +
            $ctrl.year,
          autoLoad: true,
          pageSize: 1000,
          onLoaded: function (args) {
            args.results.forEach(function (obj) {
              $ctrl.activities.conversions += obj.conversionCount;
              $ctrl.activities.salesAmount += obj.salesTotal;
            });
            $ctrl.activities.percentConverted = Math.round(
              ($ctrl.activities.conversions / $ctrl.activities.count) * 100
            );
            $ctrl.loadConvChartData();
          },
        });
        $ctrl.showAppointmentGoals = new AutoQuery({
          url:
            "QueryShowGoals.json?showCode=" +
            $ctrl.showCode +
            "&year=" +
            $ctrl.year +
            "&activityType=" +
            $ctrl.activityType +
            "&Sum=NumActivities&GroupBy=ShowCode",
          autoLoad: true,
          pageSize: 1000,
          onLoaded: function (args) {
            args.results.forEach(function (total) {
              $ctrl.numAppointmentsGoal += total.sumNumActivities;
            });
            $ctrl.showDollarGoals = new AutoQuery({
              url:
                "QueryShowGoals.json?showCode=" +
                $ctrl.showCode +
                "&year=" +
                $ctrl.year +
                "&Sum=DollarAmount&GroupBy=ShowCode",
              autoLoad: true,
              pageSize: 1000,
              onLoaded: function (args) {
                args.results.forEach(function (total) {
                  $ctrl.dollarAmountGoal += total.sumDollarAmount;
                });
                $ctrl.loadApptChartData();
              },
            });
          },
        });
      },
    });

    $ctrl.chartColors = salesrepConfig.chartColors;

    $ctrl.dailyapptdatasetOverride = [
      {
        yAxisID: "y-axis-1",
        label: "Appointments",
        borderWidth: 1,
        type: "line",
      },
      {
        yAxisID: "y-axis-2",
        label: "Projected $",
        borderWidth: 1,
        type: "line",
      },
    ];

    $ctrl.colors = salesrepConfig.chartColors;
    $ctrl.dailyapptchartOptions = {
      maintainAspectRatio: false,
      legend: {
        display: true,
        labels: {
          boxWidth: 5,
          fontSize: 10,
        },
      },
      elements: {
        rectangle: {
          borderWidth: 1,
        },
      },
      scales: {
        yAxes: [
          {
            id: "y-axis-1",
            type: "linear",
            display: true,
            position: "left",
          },
          {
            id: "y-axis-2",
            type: "linear",
            display: true,
            position: "right",
            ticks: {
              callback: function (value, index, values) {
                return (
                  "$" + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                );
              },
            },
          },
        ],
      },
      tooltips: {
        enabled: true,
        callbacks: {
          label: function (tooltipItem, data) {
            var label = data.datasets[tooltipItem.datasetIndex].label;
            var datasetLabel =
              data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            return (
              label +
              ": " +
              datasetLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            );
          },
        },
      },
    };
    $ctrl.apptchartOptions = {
      maintainAspectRatio: false,
      legend: {
        display: true,
        labels: {
          boxWidth: 5,
          fontSize: 10,
        },
      },
      elements: {
        rectangle: {
          borderWidth: 1,
        },
      },
      scales: {
        yAxes: [
          {
            display: true,
            ticks: {
              min: 0,
            },
          },
        ],
      },
      tooltips: {
        enabled: true,
      },
    };
    $ctrl.convchartOptions = {
      maintainAspectRatio: false,
      legend: {
        display: true,
        labels: {
          boxWidth: 5,
          fontSize: 10,
        },
      },
      elements: {
        rectangle: {
          borderWidth: 1,
        },
      },
      scales: {
        yAxes: [
          {
            display: true,
            ticks: {
              min: 0,
            },
          },
        ],
      },
      tooltips: {
        enabled: true,
      },
    };
  }

  getMarkets() {
    const $ctrl = this;
    if ($ctrl.showCode) {
      $ctrl.bus
        .send(
          `QueryMarketDates.json?Fields=Market&GroupBy=Market&ShowCode=${$ctrl.showCode}`
        )
        .then(function (res) {
          $ctrl.markets = res.data.results;
          if (res.data.total == 1) {
            $ctrl.market = $ctrl.markets[0].market;
          }
        });
    }
  }

  getDates() {
    const $ctrl = this;
    if ($ctrl.showCode && $ctrl.market && $ctrl.year) {
      $ctrl.bus
        .send(
          `QueryMarketDates.json?ShowCode=${$ctrl.showCode}&Market=${$ctrl.market}&Year=${$ctrl.year}`
        )
        .then(function (res) {
          $ctrl.days = res.data.results;
          if ($ctrl.days.length) {
            $ctrl.days.map((d) => {
              d.showDateFormat = moment.utc(d.showDate).format("MM/DD/YYYY");
            });
            $ctrl.beginDay = $ctrl.days[0].dayNum;
            $ctrl.endDay = $ctrl.days[$ctrl.days.length - 1].dayNum;
            $ctrl.projectionShowCode =
              $ctrl.days[0].projectionShowCode || $ctrl.showCode;
            $ctrl.projectionDollar = $ctrl.days[0].projectionDollar;
          }
          $ctrl.refreshData();
        });
    }
  }
  refreshData() {
    const $ctrl = this;
    $ctrl.showDailyTotals.criteria.showCode = $ctrl.showCode;
    $ctrl.showDailyTotals.criteria.market = $ctrl.market;
    $ctrl.showDailyTotals.criteria.year = $ctrl.year;

    $ctrl.showDailyTotalsLY.criteria.showCode = $ctrl.showCode;
    $ctrl.showDailyTotalsLY.criteria.market = $ctrl.market;
    $ctrl.showDailyTotalsLY.criteria.year = moment
      .utc("01/01/" + $ctrl.year, "MM/DD/YYYY")
      .subtract(1, "years")
      .format("YYYY");

    $ctrl.showGoals.criteria.showCode = $ctrl.showCode;
    $ctrl.showGoals.criteria.year = $ctrl.year;

    $ctrl.customersQuery.criteria.showCode = $ctrl.showCode;
    $ctrl.customersQuery.criteria.market = $ctrl.market;
    $ctrl.customersQuery.criteria.year = $ctrl.year;

    $ctrl.regionQuery.criteria.showCode = $ctrl.showCode;
    $ctrl.regionQuery.criteria.market = $ctrl.market;
    $ctrl.regionQuery.criteria.year = $ctrl.year;
    $ctrl.regionQuery.criteria.beginDay = $ctrl.beginDay;
    $ctrl.regionQuery.criteria.endDay = $ctrl.endDay;

    $ctrl.regionCustomerQuery.criteria.showCode = $ctrl.showCode;
    $ctrl.regionCustomerQuery.criteria.market = $ctrl.market;
    $ctrl.regionCustomerQuery.criteria.year = $ctrl.year;
    $ctrl.regionCustomerQuery.criteria.beginDay = $ctrl.beginDay;
    $ctrl.regionCustomerQuery.criteria.endDay = $ctrl.endDay;

    $ctrl.categoryQuery.criteria.showCode = $ctrl.showCode;
    $ctrl.categoryQuery.criteria.market = $ctrl.market;
    $ctrl.categoryQuery.criteria.year = $ctrl.year;
    $ctrl.categoryQuery.criteria.beginDay = $ctrl.beginDay;
    $ctrl.categoryQuery.criteria.endDay = $ctrl.endDay;

    $ctrl.categoryDailyQuery.criteria.showCode = $ctrl.showCode;
    $ctrl.categoryDailyQuery.criteria.market = $ctrl.market;
    $ctrl.categoryDailyQuery.criteria.year = $ctrl.year;
    $ctrl.categoryDailyQuery.criteria.beginDay = $ctrl.beginDay;
    $ctrl.categoryDailyQuery.criteria.endDay = $ctrl.endDay;

    $ctrl.vendorQuery.criteria.showCode = $ctrl.showCode;
    $ctrl.vendorQuery.criteria.market = $ctrl.market;
    $ctrl.vendorQuery.criteria.year = $ctrl.year;
    $ctrl.vendorQuery.criteria.beginDay = $ctrl.beginDay;
    $ctrl.vendorQuery.criteria.endDay = $ctrl.endDay;

    $ctrl.vendorDailyQuery.criteria.showCode = $ctrl.showCode;
    $ctrl.vendorDailyQuery.criteria.market = $ctrl.market;
    $ctrl.vendorDailyQuery.criteria.year = $ctrl.year;
    $ctrl.vendorDailyQuery.criteria.beginDay = $ctrl.beginDay;
    $ctrl.vendorDailyQuery.criteria.endDay = $ctrl.endDay;

    $ctrl.showDailyTotals.load();
  }
  exportQuickReport(report) {
    const $ctrl = this;
    let url = $ctrl.$appConfig.resolveServiceUrl(
      "RunReport?reportName=QuickReport&displayName=" +
        report.name +
        " &output=xlsx&QuickReportID=" +
        report.id +
        "&QuickReportName=" +
        report.name
    );

    return (location.href = url);
  }
}

export default ShowroomDashboardController;
